import { useAuth } from "@/providers/auth";
import { useUser } from "@/providers/user";
import { useCRM } from "@/providers/crm";
import { Undo2 } from "lucide-react";
import { useEffect, useState } from "react";

export function ViewAsBanner() {
    const { viewAsActive, deactivateViewAs } = useAuth();
    const { user } = useUser();
    const { clearCache } = useCRM();
    const [remaining, setRemaining] = useState<number | null>(null);

    useEffect(() => {
        if (!viewAsActive) {
            setRemaining(null);
            return;
        }
        const tokensRaw = localStorage.getItem("view_as_tokens");
        if (!tokensRaw) {
            setRemaining(null);
            return;
        }
        const tokens = JSON.parse(tokensRaw);
        if (!tokens.access_expires) {
            setRemaining(null);
            return;
        }
        const update = () => {
            const now = Math.floor(Date.now() / 1000);
            const diff = tokens.access_expires - now;
            setRemaining(diff > 0 ? diff : 0);
        };
        update();
        const interval = setInterval(update, 1000);
        return () => clearInterval(interval);
    }, [viewAsActive]);

    if (!viewAsActive) return null;

    // Format mm:ss
    const formatTime = (s: number | null) => {
        if (s === null) return "";
        const m = Math.floor(s / 60);
        const sec = s % 60;
        return `${m.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
    };

    return (
        <div className="z-50 flex w-full items-center justify-between border-b bg-straw-yellow px-8 text-gray-800">
            <span className="mr-4 flex items-center text-sm font-semibold text-gray-800">
                "View as" is currently active:
                {user && (
                    <>
                        {" "}
                        {user.first_name} {user.last_name} with email {user.email}
                    </>
                )}
                {remaining !== null && <span className="ml-4 flex items-center rounded-sm border border-gray-800 px-2  text-sm">Time left: {formatTime(remaining)}</span>}
            </span>
            <div
                className="flex cursor-pointer items-center rounded-sm px-2 py-1.5 text-sm font-semibold text-gray-800"
                onClick={() => {
                    deactivateViewAs();
                    clearCache();
                }}
            >
                <Undo2 className="mr-2 inline-grid text-gray-800" size={16} /> Back to my account
            </div>
        </div>
    );
}
